import setLatestRenderedQFTraceId from '../actions/setLatestRenderedQFTraceId';
import getScenarioStore from '../store/getScenarioStore';
import { mutator } from 'satcheljs';

/*
 * This mutator is temporary and should only be used
 * with the sea-zinq-3sctr custom control flight
 */
mutator(setLatestRenderedQFTraceId, actionMessage => {
    const { latestRenderedQFTraceId, scenarioId } = actionMessage;

    getScenarioStore(scenarioId).latestRenderedQFTraceId = latestRenderedQFTraceId;
});
